// Purchase configurator for sections/neuracoil-product-page.liquid. Liquid values arrive
// through <script type="application/json" data-neuracoil-product-config> in the section.
(() => {
  const initialize = (config) => {
  const sectionId = config.sectionId;
  const section = document.getElementById(sectionId);
  if (!section || section.dataset.neuracoilProductReady === 'true') return;
  section.dataset.neuracoilProductReady = 'true';

  const variantsScript = section.querySelector('[data-neuracoil-variants]');
  const accessoryCatalog = JSON.parse(section.querySelector('[data-neuracoil-accessories]')?.textContent || '{}');
  const cartError = section.querySelector('[data-cart-error]');
  const cartErrorText = config.cartErrorText;
  const unavailableText = config.unavailableText;
  const cartUrl = config.cartUrl;
  const cartAddUrl = config.cartAddUrl;
  let cartSubmitting = false;
  const mediaScript = section.querySelector('[data-neuracoil-media]');
  const form = section.querySelector('.neuracoil-product-page__form');
  const variantInput = section.querySelector('[data-variant-id-input]');
  const price = section.querySelector('[data-product-price]');
  const priceNote = section.querySelector('[data-product-price-note]');
  const mobilePrice = section.querySelector('[data-mobile-product-price]');
  const addButton = section.querySelector('[data-add-to-cart]');
  const addLabel = section.querySelector('[data-add-to-cart-label]');
  const buyNowButton = section.querySelector('[data-buy-now]');
  const returnToInput = section.querySelector('[data-return-to-input]');
  const purchaseActions = section.querySelector('[data-purchase-actions]');
  const checkoutShell = section.querySelector('[data-checkout-shell]');
  const waitlistPanel = section.querySelector('[data-waitlist-panel]');
  const notifyShell = section.querySelector('[data-notify-shell]');
  const notifyForm = section.querySelector('.neuracoil-product-page__notify-form');
  const notifyEmailInput = section.querySelector('.neuracoil-product-page__notify-input');
  const notifyTagsInput = section.querySelector('[data-notify-tags-input]');
  const notifyProductLabel = section.querySelector('[data-notify-product-label]');
  const reserveBuildButton = section.querySelector('[data-reserve-build]');
  const soundDemoCtas = Array.from(section.querySelectorAll('[data-sound-demo-cta]'));
  const notifyHasMessage = Boolean(section.querySelector('[data-notify-success], .neuracoil-product-page__notify-message.is-error'));
  const trustWaitlist = section.querySelector('[data-trust-waitlist]');
  const trustCheckout = section.querySelector('[data-trust-checkout]');
  const quantityInput = section.querySelector('[data-quantity-input]');
  const mainImage = section.querySelector('[data-main-product-image]');
  const doubleBonusInput = section.querySelector('[data-double-bonus-input]');
  const stockStatus = section.querySelector('[data-stock-status]');
  const deliveryStatus = section.querySelector('[data-delivery-status]');
  const selectedSummary = section.querySelector('[data-selected-summary]');
  const mobileSelectedSummary = section.querySelector('[data-mobile-selected-summary]');
  const selectedAddonsSummary = section.querySelector('[data-selected-addons]');
  const batteryCapacityGroup = section.querySelector('[data-battery-capacity-group]');
  const batteryCapacityInputs = Array.from(section.querySelectorAll('[data-battery-capacity-input]'));
  const batteryCapacitySummary = section.querySelector('[data-battery-capacity-summary]');
  const hasAddonGroup = Boolean(section.querySelector('[data-addon-group]'));
  const productTitle = config.productTitle;
  const productHasOnlyDefaultVariant = config.productHasOnlyDefaultVariant;
  const storefrontLocale = config.storefrontLocale;
  const storefrontCurrency = config.storefrontCurrency;
  const stockStatusText = config.stockStatusText;
  const deliveryStatusText = config.deliveryStatusText;
  const addBaseLabel = addLabel?.dataset.addToCartBaseLabel || 'Add to Cart';
  const addUnavailableLabel = addLabel?.dataset.addToCartUnavailableLabel || 'Join waitlist';
  const quantitySummary = section.querySelector('[data-quantity-summary]');
  let currentVariant = null;

  const normalizeStorefrontUrl = (value) => {
    if (!value) return value;

    try {
      const url = new URL(value, window.location.origin);
      if (url.pathname.startsWith('/cdn/')) {
        return `${window.location.origin}${url.pathname}${url.search}`;
      }

      return url.href;
    } catch (error) {
      return value;
    }
  };

  const variants = variantsScript ? JSON.parse(variantsScript.textContent).map((variant) => ({
    ...variant,
    image: normalizeStorefrontUrl(variant.image)
  })) : [];
  const mediaItems = mediaScript ? JSON.parse(mediaScript.textContent).map((item) => ({
    ...item,
    src: normalizeStorefrontUrl(item.src),
    blackSrc: normalizeStorefrontUrl(item.blackSrc),
    avifSrc: normalizeStorefrontUrl(item.avifSrc),
    blackAvifSrc: normalizeStorefrontUrl(item.blackAvifSrc)
  })) : [];
  // The finish gallery has AVIF siblings that are about a quarter smaller at
  // equal measured quality (scripts/export-avif-variants.py). The first image
  // stays WebP so the startup path is unchanged; later views and warmed
  // neighbours switch to AVIF once this browser has decoded a 1 px probe.
  let avifDecodes = false;
  const avifProbe = new Image();
  avifProbe.onload = () => { avifDecodes = avifProbe.naturalWidth > 0; };
  avifProbe.src = 'data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADrbWV0YQAAAAAAAAAhaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAAAAAAAOcGl0bQAAAAAAAQAAAB5pbG9jAAAAAEQAAAEAAQAAAAEAAAETAAAAIQAAAChpaW5mAAAAAAABAAAAGmluZmUCAAAAAAEAAGF2MDFDb2xvcgAAAABqaXBycAAAAEtpcGNvAAAAFGlzcGUAAAAAAAAAAQAAAAEAAAAQcGl4aQAAAAADCAgIAAAADGF2MUOBAAwAAAAAE2NvbHJuY2x4AAEADQAGgAAAABdpcG1hAAAAAAAAAAEAAQQBAoMEAAAAKW1kYXQSAAoIGAAGiAhoNCAyExlHh4Yhh5555oAAAJBAyRxhQr4=';
  const finishMedia = (item, black, current = '') => {
    const useBlack = Boolean(black && item.blackSrc);
    const webp = { src: useBlack ? item.blackSrc : item.src, srcset: useBlack ? item.blackSrcset : item.srcset };
    const avifSrc = avifDecodes ? (useBlack ? item.blackAvifSrc : item.avifSrc) : '';
    // Never fetch a view that is showing or was the first image (already
    // cached as WebP) just to change its format.
    if (!avifSrc || normalizeStorefrontUrl(current) === webp.src || webp.src === initialMainImageSrc) return webp;
    return { src: avifSrc, srcset: useBlack ? item.blackAvifSrcset : item.avifSrcset };
  };
  const initialNotifyTags = notifyTagsInput?.value || '';
  const mediaThumbs = Array.from(section.querySelectorAll('[data-media-thumb]'));
  const imageAttribute = (image, name) => image?.getAttribute(name) || '';
  const setImageAttribute = (image, name, value) => {
    if (value) image.setAttribute(name, value); else image.removeAttribute(name);
  };
  const initialMainImageSrc = normalizeStorefrontUrl(imageAttribute(mainImage, 'src'));
  let currentMediaIndex = Math.max(
    0,
    mediaItems.findIndex((item) => initialMainImageSrc === item.src)
  );

  const pairImage = section.classList.contains('nc-purchase') && mainImage ? mainImage.cloneNode(false) : null;
  if (pairImage) {
    pairImage.removeAttribute('data-main-product-image');
    pairImage.removeAttribute('id');
    pairImage.classList.add('nc-purchase__second-pickup');
    pairImage.setAttribute('aria-hidden', 'true');
    pairImage.alt = '';
    mainImage.parentElement.append(pairImage);
  }
  const syncPairImage = () => {
    if (!pairImage || !mainImage) return;
    setImageAttribute(pairImage, 'srcset', imageAttribute(mainImage, 'srcset'));
    setImageAttribute(pairImage, 'src', imageAttribute(mainImage, 'src'));
    pairImage.sizes = mainImage.sizes;
  };

  // Double builds show the free blade switch beside the two pickups, in the
  // perspective of the current view. Nothing is fetched until Double is chosen.
  const bonusImages = JSON.parse(section.querySelector('[data-bonus-images]')?.textContent || 'null');
  const bonusViews = { Front: 'front', Angle: 'angle', Top: 'top', Side: 'angle', Detail: 'angle' };
  const bonusImage = pairImage && bonusImages ? document.createElement('img') : null;
  if (bonusImage) {
    bonusImage.className = 'nc-purchase__bonus-image';
    bonusImage.alt = '';
    bonusImage.setAttribute('aria-hidden', 'true');
    bonusImage.decoding = 'async';
    bonusImage.sizes = '(min-width: 990px) 14rem, 32vw';
    bonusImage.addEventListener('load', () => bonusImage.classList.add('is-loaded'));
    mainImage.parentElement.append(bonusImage);
  }
  let bonusWarmed = false;
  const syncBonusImage = () => {
    if (!bonusImage || !section.classList.contains('nc-purchase--double')) return;
    const view = bonusViews[section.dataset.purchaseView] || 'front';
    const source = bonusImages[view];
    if (!source || bonusImage.dataset.view === view) return;
    bonusImage.dataset.view = view;
    bonusImage.srcset = source.srcset;
    bonusImage.src = source.src;
    if (bonusWarmed) return;
    bonusWarmed = true;
    // The other perspectives are small; warm them so view changes stay instant.
    Object.values(bonusImages).forEach((other) => {
      if (other === source) return;
      const warm = new Image();
      warm.fetchPriority = 'low';
      warm.sizes = bonusImage.sizes;
      warm.srcset = other.srcset;
      warm.src = other.src;
    });
  };

  const syncMediaThumbs = () => {
    mediaThumbs.forEach((thumb, index) => {
      const isActive = index === currentMediaIndex;
      thumb.classList.toggle('is-active', isActive);
      thumb.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  };

  const preparedMedia = new Map();
  const decodedMedia = new Set();
  let mediaSwapToken = 0;
  const prepareMedia = (src, srcset, sizes, priority = 'auto') => {
    if (preparedMedia.has(src)) return preparedMedia.get(src);
    const image = new Image();
    image.fetchPriority = priority;
    image.sizes = sizes;
    const ready = new Promise((resolve) => {
      image.onload = async () => {
        await image.decode().catch(() => {});
        decodedMedia.add(src);
        resolve(image);
      };
      image.onerror = () => {
        preparedMedia.delete(src);
        resolve(null);
      };
      if (srcset) image.srcset = srcset;
      image.src = src;
    });
    preparedMedia.set(src, ready);
    return ready;
  };

  let adjacentMediaWaiting = false, adjacentMediaReleased = false;
  const warmAdjacentMedia = (black) => {
    if (navigator.connection?.saveData) return;
    if (!adjacentMediaReleased && document.querySelector('[data-nc-journey]') && document.documentElement.dataset.ncJourneyPrepared !== 'true') {
      if (!adjacentMediaWaiting) {
        adjacentMediaWaiting = true;
        const release = () => {
          if (adjacentMediaReleased) return;
          adjacentMediaReleased = true;
          clearTimeout(timeout);
          const selected = section.querySelector('[data-option-kind="color"] [aria-pressed="true"]');
          warmAdjacentMedia(/black/i.test(selected?.dataset.optionLabel || selected?.dataset.optionValue || ''));
        };
        window.addEventListener('nc:journey-prepared', release, { once: true });
        const timeout = setTimeout(release, 8000);
      }
      return;
    }
    const warm = () => {
      const slowConnection = navigator.connection?.effectiveType === '3g' || navigator.connection?.effectiveType === '2g' || (navigator.connection?.downlink ?? Infinity) < 2;
      (slowConnection ? [1] : [-1, 1]).forEach(offset => {
        const item = mediaItems[(currentMediaIndex + offset + mediaItems.length) % mediaItems.length];
        if (!item) return;
        const media = finishMedia(item, black);
        prepareMedia(media.src, media.srcset, item.sizes || mainImage.sizes, 'low');
      });
    };
    if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 2500 });
    else setTimeout(warm, 600);
  };

  const mediaFrame = mainImage?.parentElement;
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mediaSource = (index) => {
    const item = mediaItems[(index + mediaItems.length) % mediaItems.length];
    const finishButton = section.querySelector('[data-option-kind="color"] [data-option-button][aria-pressed="true"]');
    const black = /black/i.test(finishButton?.dataset.optionLabel || finishButton?.dataset.optionValue || '');
    return item ? { item, black, ...finishMedia(item, black, imageAttribute(mainImage, 'src')) } : null;
  };
  // Start the next picture on press, before the click arrives.
  const preloadMedia = (index) => {
    if (!section.classList.contains('nc-purchase') || !mainImage) return;
    const media = mediaSource(index);
    if (media) prepareMedia(media.src, media.srcset, media.item.sizes || mainImage.sizes, 'high');
  };
  let galleryWarmed = false;
  const warmGallery = () => {
    if (galleryWarmed || navigator.connection?.saveData) return;
    galleryWarmed = true;
    mediaItems.forEach((item, index) => {
      const media = mediaSource(index);
      if (media) prepareMedia(media.src, media.srcset, item.sizes || mainImage.sizes, 'low');
    });
  };

  const setMedia = (index, direction = 1) => {
    if (!mainImage || !mediaItems.length) return;

    currentMediaIndex = (index + mediaItems.length) % mediaItems.length;
    const item = mediaItems[currentMediaIndex];
    const finishButton = section.querySelector('[data-option-kind="color"] [data-option-button][aria-pressed="true"]');
    const black = /black/i.test(finishButton?.dataset.optionLabel || finishButton?.dataset.optionValue || '');
    const { src: finishSrc, srcset: finishSrcset } = finishMedia(item, black, imageAttribute(mainImage, 'src'));
    const sizes = item.sizes || '(min-width: 990px) min(44vw, 44rem), 92vw';
    const applyMedia = () => {
      setImageAttribute(mainImage, 'srcset', finishSrcset || '');
      mainImage.sizes = sizes;
      setImageAttribute(mainImage, 'src', finishSrc);
      mainImage.alt = `${item.alt || ''}${item.blackSrc ? ' — ' + (black ? 'Black anodized aluminium' : 'Silver anodized aluminium') : ''}`;
      if (section.classList.contains('nc-purchase')) section.dataset.purchaseView = item.label || '';
      syncPairImage();
      syncBonusImage();
    };
    const token = ++mediaSwapToken;
    if (!section.classList.contains('nc-purchase') || imageAttribute(mainImage, 'src') === finishSrc) {
      applyMedia();
    } else {
      const ready = prepareMedia(finishSrc, finishSrcset, sizes, 'high');
      const shift = reducedMotionQuery.matches ? 0 : 2.4;
      // Leave towards the travelled direction; dim only while the next one loads.
      mediaFrame.style.setProperty('--nc-swap-shift', `${-direction * shift}%`);
      mediaFrame.dataset.swap = decodedMedia.has(finishSrc) ? 'out' : 'wait';
      const left = new Promise((resolve) => setTimeout(resolve, reducedMotionQuery.matches ? 0 : 160));
      Promise.all([ready, left]).then(async ([image]) => {
        if (token !== mediaSwapToken) return;
        if (!image) {
          delete mediaFrame.dataset.swap;
          return;
        }
        mediaFrame.dataset.swap = 'hold';
        mediaFrame.style.setProperty('--nc-swap-shift', `${direction * shift}%`);
        applyMedia();
        await mainImage.decode().catch(() => {});
        if (token !== mediaSwapToken) return;
        void mediaFrame.offsetWidth;
        delete mediaFrame.dataset.swap;
        warmAdjacentMedia(black);
      });
    }
    mediaThumbs.forEach((thumb, i) => {
      const image = thumb.querySelector('img');
      const src = black ? mediaItems[i]?.blackThumb : mediaItems[i]?.silverThumb;
      if (image && src) { setImageAttribute(image, 'srcset', ''); setImageAttribute(image, 'src', src); }
    });
    syncMediaThumbs();
  };

  const selectedOptions = () => {
    const options = [];

    section.querySelectorAll('[data-option-group]').forEach((group) => {
      const active = group.querySelector('[data-option-button][aria-pressed="true"]');
      const index = Number(group.dataset.optionPosition || 1) - 1;
      options[index] = active ? active.dataset.optionValue : '';
    });

    return options;
  };

  const selectedOptionLabels = () => {
    const labels = [];

    section.querySelectorAll('[data-option-group]').forEach((group) => {
      const active = group.querySelector('[data-option-button][aria-pressed="true"]');
      const index = Number(group.dataset.optionPosition || 1) - 1;
      let label = active ? (active.dataset.optionLabel || active.dataset.optionValue || '') : '';

      if (group.dataset.optionKind === 'strings' && label && !label.toLowerCase().includes('string')) {
        label = `${label}-string`;
      }

      labels[index] = {
        kind: group.dataset.optionKind || 'standard',
        label
      };
    });

    return labels;
  };

  const selectedBuildOptionLabels = () => {
    const labels = selectedOptionLabels().filter((item) => item?.label);
    const orderedKinds = ['strings', 'color', 'pack', 'battery'];
    const ordered = orderedKinds
      .map((kind) => labels.find((item) => item.kind === kind)?.label)
      .filter(Boolean);
    const remaining = labels
      .filter((item) => !orderedKinds.includes(item.kind))
      .map((item) => item.label)
      .filter(Boolean);

    return [...ordered, ...remaining];
  };

  const selectedBatteryCapacity = () => {
    const checked = batteryCapacityInputs.find((input) => input.checked);
    return checked?.value || '';
  };

  const addonVariant = (input) => {
    const id = input.hasAttribute('data-addon-battery')
      ? batteryCapacityInputs.find((candidate) => candidate.checked)?.dataset.addonVariantId
      : input.value;
    const variant = accessoryCatalog[input.dataset.addonKey]?.variants?.find((candidate) => String(candidate.id) === String(id));
    // The Double bonus keeps its variant and SKU but adds nothing to the total.
    return variant && input.hasAttribute('data-addon-bonus') ? { ...variant, price: 0 } : variant;
  };

  const selectedAccessoryVariants = () => Array.from(section.querySelectorAll('[data-addon-key]:checked')).map(addonVariant);
  const currentBuild = (quantity = selectedQuantity()) => window.NeuraCoilBuild.resolve(currentVariant, selectedAccessoryVariants(), quantity);

  const syncAccessoryPrices = () => {
    section.querySelectorAll('[data-addon-key]').forEach((input) => {
      const variant = addonVariant(input);
      const output = input.closest('[data-addon-choice]')?.querySelector('[data-addon-price]');
      if (output && variant && !input.hasAttribute('data-addon-bonus')) output.textContent = `+${formatMoney(variant.price)}`;
      input.dataset.variantId = variant?.id || '';
      input.dataset.sku = variant?.sku || '';
    });
  };

  const selectedAddonLabels = () => {
    const selectedAddons = Array.from(section.querySelectorAll('[data-addon-input]:not([data-addon-none]):checked'))
      .map((input) => {
        const choice = input.closest('[data-addon-choice]');
        const title = choice?.querySelector('.neuracoil-product-page__variant-title')?.textContent?.trim();
        const hint = choice?.querySelector('.neuracoil-product-page__variant-hint')?.textContent?.trim();
        if (input.hasAttribute('data-addon-bonus')) {
          const label = choice?.querySelector('[data-addon-price]')?.textContent?.trim();
          return label ? `${title} (${label})` : title;
        }
        const capacity = input.hasAttribute('data-addon-battery') ? selectedBatteryCapacity() : '';
        return [title, hint, capacity].filter(Boolean).join(' ');
      })
      .filter(Boolean);

    if (selectedAddons.length) return selectedAddons;

    const noneInput = section.querySelector('[data-addon-none]:checked');
    const noneChoice = noneInput?.closest('[data-addon-choice]');
    const noneTitle = noneChoice?.querySelector('.neuracoil-product-page__variant-title')?.textContent?.trim();

    return noneTitle ? [noneTitle] : [];
  };

  const selectedConfigurationLabel = () => {
    const optionLabel = selectedBuildOptionLabels().filter(Boolean).join(section.classList.contains('nc-purchase') ? ' · ' : ' / ');
    const fallbackLabel = productHasOnlyDefaultVariant ? 'Standard configuration' : currentVariant?.title;
    const addOns = selectedAddonLabels();

    return [optionLabel || fallbackLabel, ...addOns].filter(Boolean).join(' + ');
  };

  const selectedBuildMainLabel = () => {
    const optionLabel = selectedBuildOptionLabels().filter(Boolean).join(section.classList.contains('nc-purchase') ? ' · ' : ' / ');
    const fallbackLabel = productHasOnlyDefaultVariant ? 'Standard configuration' : currentVariant?.title;

    return optionLabel || fallbackLabel || '';
  };

  const selectedBuildAddonLabel = () => {
    if (!hasAddonGroup) return '';

    return selectedAddonLabels().join(' + ') || 'Pickups only';
  };

  const trackProductEvent = (eventName, detail = {}) => {
    const variant = currentVariant || variants.find((candidate) => String(candidate.id) === String(variantInput?.value));
    const eventDetail = {
      productTitle,
      variantId: variant?.id || variantInput?.value || '',
      variantTitle: selectedConfigurationLabel(),
      ...detail
    };

    window.dispatchEvent(new CustomEvent(`neuracoil:${eventName}`, { detail: eventDetail }));

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: `neuracoil_${eventName}`,
        ...eventDetail
      });
    }
  };

  const setCheckoutDestination = (value) => {
    if (!(returnToInput instanceof HTMLInputElement)) return;

    returnToInput.value = value || '/checkout';
    returnToInput.disabled = !value;
  };

  const syncPurchaseMessaging = (variant = currentVariant) => {
    const available = currentBuild().available;
    const buildMainLabel = selectedBuildMainLabel();
    const buildAddonLabel = selectedBuildAddonLabel();

    if (stockStatus instanceof HTMLElement) {
      stockStatus.textContent = stockStatusText;
      stockStatus.classList.toggle('is-unavailable', !available);
    }

    if (deliveryStatus instanceof HTMLElement) {
      deliveryStatus.textContent = deliveryStatusText;
    }

    if (selectedSummary instanceof HTMLElement) {
      selectedSummary.textContent = buildMainLabel;
    }

    if (mobileSelectedSummary instanceof HTMLElement) {
      mobileSelectedSummary.textContent = buildMainLabel;
    }

    if (selectedAddonsSummary instanceof HTMLElement) {
      selectedAddonsSummary.textContent = buildAddonLabel;
    }

    if (buyNowButton instanceof HTMLButtonElement) buyNowButton.disabled = !available || cartSubmitting;
    if (addButton instanceof HTMLButtonElement) addButton.disabled = !available || cartSubmitting;
    if (purchaseActions) purchaseActions.hidden = !available;
    if (checkoutShell) checkoutShell.hidden = !available;
    if (waitlistPanel) waitlistPanel.hidden = available && !notifyHasMessage;
    if (notifyShell) notifyShell.hidden = available && !notifyHasMessage;
    if (trustWaitlist) trustWaitlist.hidden = available;
    if (trustCheckout) trustCheckout.hidden = !available;
    const quantityShell = section.querySelector('[data-quantity-shell]');
    if (section.classList.contains('nc-purchase') && quantityShell) quantityShell.hidden = !available;
  };

  const toNotifyTagSegment = (value) => String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const syncNotifyLabel = () => {
    const configurationLabel = selectedConfigurationLabel();

    if (notifyProductLabel) {
      notifyProductLabel.textContent = `We'll email you when ${configurationLabel} is ready for checkout.`;
    }

    if (notifyTagsInput instanceof HTMLInputElement) {
      const variantTags = currentVariant?.notifyTags || initialNotifyTags;
      const configurationTag = toNotifyTagSegment(configurationLabel);
      const accessoryTags = selectedAccessoryVariants().filter(Boolean).flatMap((variant) => [
        `accessory-variant-id:${variant.id}`, variant.sku ? `accessory-sku:${variant.sku}` : ''
      ]);
      const build = currentBuild();
      // Double builds include the blade switch; the reservation records it.
      const bonusTag = section.querySelector('[data-addon-bonus]:checked') ? 'bonus:5-way-blade-switch' : '';
      notifyTagsInput.value = [variantTags, ...accessoryTags, `configuration-total:${storefrontCurrency}-${build.totalCents}`, `configuration-quantity:${build.quantity}`, configurationTag ? `configuration:${configurationTag}` : '', bonusTag]
        .filter(Boolean)
        .join(',');
    }
  };

  const numericValue = (value, fallback) => {
    const number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  };

  const formatMoney = (cents) => {
    const amount = numericValue(cents, 0) / 100;
    const hasDecimals = Math.round(numericValue(cents, 0)) % 100 !== 0;

    try {
      return new Intl.NumberFormat(storefrontLocale || document.documentElement.lang || 'en', {
        style: 'currency',
        currency: storefrontCurrency,
        currencyDisplay: 'code',
        minimumFractionDigits: hasDecimals ? 2 : 0,
        maximumFractionDigits: hasDecimals ? 2 : 0
      }).format(amount).replace(/\s+/g, ' ');
    } catch (error) {
      return `${storefrontCurrency} ${hasDecimals ? amount.toFixed(2) : Math.round(amount)}`;
    }
  };

  const quantityMinimum = () => Math.max(numericValue(quantityInput?.min || quantityInput?.dataset.quantityMin, 1), 1);
  const quantityStep = () => Math.max(numericValue(quantityInput?.step || quantityInput?.dataset.quantityStep, 1), 1);
  const quantityMaximum = () => {
    const value = numericValue(quantityInput?.max || quantityInput?.dataset.quantityMax, NaN);
    return Number.isFinite(value) && value >= quantityMinimum() ? value : null;
  };

  const normalizeQuantity = (value) => {
    if (!quantityInput) return 1;

    const min = quantityMinimum();
    const step = quantityStep();
    const max = quantityMaximum();
    const requestedQuantity = Math.max(numericValue(value, min), min);
    let quantity = min + Math.round((requestedQuantity - min) / step) * step;

    if (max !== null) {
      quantity = Math.min(quantity, max);
    }

    return Math.max(quantity, min);
  };

  const selectedQuantity = () => normalizeQuantity(quantityInput?.value);

  const currentUnitPriceCents = () => currentBuild(1).totalCents;

  const syncPriceDisplay = (quantity = selectedQuantity()) => {
    const unitPriceCents = currentUnitPriceCents();

    if (price instanceof HTMLElement && currentBuild().valid) {
      price.textContent = formatMoney(unitPriceCents * quantity);
    }

    if (mobilePrice instanceof HTMLElement && currentBuild().valid) {
      mobilePrice.textContent = formatMoney(unitPriceCents * quantity);
    }

    if (priceNote instanceof HTMLElement) {
      if (quantity > 1 && unitPriceCents > 0) {
        priceNote.textContent = `${formatMoney(unitPriceCents)} each`;
        priceNote.hidden = false;
      } else {
        priceNote.textContent = '';
        priceNote.hidden = true;
      }
    }
  };

  const dispatchProductContext = () => {
    const variant = currentVariant || variants.find((candidate) => String(candidate.id) === String(variantInput?.value));
    const quantity = selectedQuantity();
    const detail = {
      productTitle,
      variantId: variant?.id || variantInput?.value || '',
      variantTitle: selectedConfigurationLabel(),
      price: price?.textContent?.trim() || variant?.price || '',
      available: currentBuild(quantity).available,
      items: currentBuild(quantity).items,
      quantity
    };

    window.neuracoilProductContext = detail;
    window.dispatchEvent(new CustomEvent('neuracoil:product-context', { detail }));
  };

  const syncQuantityControls = (value, options = {}) => {
    const shouldDispatch = options.dispatch !== false;
    const shouldCommit = options.commit !== false;
    const quantity = normalizeQuantity(value);

    if (quantityInput && shouldCommit) {
      quantityInput.value = String(quantity);
    }

    if (quantitySummary instanceof HTMLElement) {
      quantitySummary.textContent = quantity === 1 ? '1 unit.' : `${quantity} units.`;
    }

    syncPriceDisplay(quantity);
    syncAccessoryPrices();
    syncNotifyLabel();

    if (addLabel instanceof HTMLElement) {
      const available = addButton instanceof HTMLButtonElement ? !addButton.disabled : true;
      addLabel.textContent = available && quantity > 1 ? `Add ${quantity} to Cart` : available ? addBaseLabel : addUnavailableLabel;
    }

    if (shouldDispatch) {
      dispatchProductContext();
    }

    return quantity;
  };

  const syncPackBonus = () => {
    if (!doubleBonusInput) return;

    const selectedPack = section.querySelector('[data-option-kind="pack"] [data-option-button][aria-pressed="true"]');
    doubleBonusInput.value = selectedPack?.dataset.doubleBonus || '';
    doubleBonusInput.disabled = doubleBonusInput.value === '';
    const packNote = section.querySelector('[data-purchase-pack-note]');
    const isDouble = Boolean(selectedPack?.dataset.doubleBonus);
    if (packNote) packNote.textContent = isDouble ? 'Two pickups.' : 'One pickup.';
    section.classList.toggle('nc-purchase--double', isDouble);
    syncBonusImage();
    const bonusChoice = section.querySelector('[data-bonus-addon]');
    const bonusInput = bonusChoice?.querySelector('[data-addon-bonus]');
    if (bonusChoice && bonusInput) {
      bonusChoice.hidden = !isDouble;
      bonusInput.checked = isDouble;
      const group = bonusChoice.closest('[data-addon-group]');
      if (group) syncAddonGroup(group);
    }
  };

  // Shareable builds on the homepage: after a change the selection is written
  // to the address bar (?strings=7&pickups=double&finish=black&addons=battery),
  // so a reload or a shared link opens the same build. Product pages keep
  // Shopify's ?variant=. Only values that differ from the default are written.
  const shareableBuild = section.classList.contains('nc-purchase') && !window.location.pathname.includes('/products/');
  const buildParams = { strings: 'strings', pack: 'pickups', color: 'finish' };
  const buildValue = (element) => String(element?.dataset.optionLabel || element?.dataset.optionValue || '').trim().toLowerCase();
  const capacityValue = (input) => String(input?.value || '').replace(/\D/g, '');
  const pressOption = (group, button) => {
    group.querySelectorAll('[data-option-button]').forEach((optionButton) => {
      optionButton.classList.toggle('is-active', optionButton === button);
      optionButton.setAttribute('aria-pressed', optionButton === button ? 'true' : 'false');
    });
    const label = button.dataset.optionLabel || button.dataset.optionValue || '';
    const selectedLabel = group.querySelector('[data-option-selected-label]');
    if (selectedLabel) selectedLabel.textContent = label;
    const headingValue = group.querySelector('[data-option-heading-value]');
    if (headingValue) headingValue.textContent = label;
  };
  const readBuildState = () => {
    const state = {};
    section.querySelectorAll('[data-option-group]').forEach((group) => {
      const key = buildParams[group.dataset.optionKind];
      if (key) state[key] = buildValue(group.querySelector('[data-option-button][aria-pressed="true"]'));
    });
    state.addons = Array.from(section.querySelectorAll('[data-addon-key]:not([data-addon-bonus]):checked')).map((input) => input.dataset.addonKey).join(',');
    // The first capacity is the default whenever the battery pack is chosen.
    const capacity = capacityValue(batteryCapacityInputs.find((input) => input.checked));
    state.capacity = section.querySelector('[data-addon-battery]:checked') && capacity !== capacityValue(batteryCapacityInputs[0]) ? capacity : '';
    return state;
  };
  const defaultBuild = shareableBuild ? readBuildState() : null;
  const applyBuildFromUrl = () => {
    if (!shareableBuild) return;
    const params = new URLSearchParams(window.location.search);
    const groups = Array.from(section.querySelectorAll('[data-option-group]'));
    const previous = groups.map((group) => [group, group.querySelector('[data-option-button][aria-pressed="true"]')]);
    groups.forEach((group) => {
      const wanted = String(params.get(buildParams[group.dataset.optionKind]) || '').toLowerCase();
      const button = wanted && Array.from(group.querySelectorAll('[data-option-button]')).find((candidate) => buildValue(candidate) === wanted);
      if (button) pressOption(group, button);
    });
    // A combination that does not exist falls back to the default build.
    const options = selectedOptions();
    if (!variants.some((variant) => variant.options.every((option, index) => option === options[index]))) {
      previous.forEach(([group, button]) => { if (button) pressOption(group, button); });
    }
    if (params.has('addons')) {
      const keys = String(params.get('addons')).split(',');
      section.querySelectorAll('[data-addon-key]:not([data-addon-bonus])').forEach((input) => {
        input.checked = keys.includes(input.dataset.addonKey) && Boolean(addonVariant(input));
      });
      const noneInput = section.querySelector('[data-addon-none]');
      if (noneInput) noneInput.checked = !section.querySelector('[data-addon-key]:not([data-addon-bonus]):checked');
    }
    const capacity = capacityValue({ value: params.get('capacity') });
    const capacityInput = capacity && batteryCapacityInputs.find((input) => capacityValue(input) === capacity);
    if (capacityInput) batteryCapacityInputs.forEach((input) => { input.checked = input === capacityInput; });
  };
  const writeBuildToUrl = () => {
    if (!shareableBuild || !defaultBuild || !window.history?.replaceState) return;
    const url = new URL(window.location.href);
    const state = readBuildState();
    Object.keys(state).forEach((key) => {
      if (state[key] && state[key] !== defaultBuild[key]) url.searchParams.set(key, state[key]);
      else url.searchParams.delete(key);
    });
    if (url.href !== window.location.href) window.history.replaceState(window.history.state, '', url);
  };

  const syncBatteryCapacityChoices = (enabled = Boolean(section.querySelector('[data-addon-battery]:checked'))) => {
    if (batteryCapacityGroup instanceof HTMLElement) {
      batteryCapacityGroup.hidden = !enabled;
    }

    if (enabled && batteryCapacityInputs.length && !batteryCapacityInputs.some((input) => input.checked)) {
      batteryCapacityInputs[0].checked = true;
    }

    const selectedCapacity = selectedBatteryCapacity();

    batteryCapacityInputs.forEach((input) => {
      input.disabled = !enabled;
      const choice = input.closest('.neuracoil-product-page__battery-choice');
      choice?.classList.toggle('is-active', enabled && input.checked);
    });

    if (batteryCapacitySummary instanceof HTMLElement) {
      batteryCapacitySummary.textContent = selectedCapacity || 'Choose';
    }
  };

  const syncAddonGroup = (group) => {
    const noneInput = group.querySelector('[data-addon-none]');
    const selectedAddons = Array.from(group.querySelectorAll('[data-addon-input]:not([data-addon-none])')).filter((input) => input.checked);
    const batterySelected = Boolean(group.querySelector('[data-addon-battery]:checked'));

    if (noneInput) {
      noneInput.checked = selectedAddons.length === 0;
    }

    group.querySelectorAll('[data-addon-choice]').forEach((choice) => {
      const choiceInput = choice.querySelector('[data-addon-input]');
      choice.classList.toggle('is-active', Boolean(choiceInput?.checked));
    });

    syncBatteryCapacityChoices(batterySelected);
  };

  const syncVariant = () => {
    if (!variants.length || !variantInput) return false;

    const options = selectedOptions();
    const variant = variants.find((candidate) => {
      return candidate.options.every((option, index) => option === options[index]);
    });

    if (!variant) return false;

    currentVariant = variant;
    variantInput.value = variant.id;
    const purchaseAvailable = currentBuild().available;

    if (window.location.pathname.includes('/products/')) {
      const variantUrl = new URL(window.location.href);
      variantUrl.searchParams.set('variant', String(variant.id));
      window.history.replaceState(window.history.state, '', variantUrl);
    }
    if (price instanceof HTMLElement) {
      price.dataset.unitPriceCents = String(variant.priceCents || '');
      price.dataset.unitPrice = variant.price || '';
    }

    if (addButton && addLabel) {
      addButton.disabled = !purchaseAvailable;
      addLabel.textContent = purchaseAvailable ? addBaseLabel : addUnavailableLabel;
    }

    syncPurchaseMessaging(variant);

    syncQuantityControls(quantityInput?.value, { dispatch: false });

    if (purchaseActions) {
      purchaseActions.hidden = !purchaseAvailable;
    }

    if (checkoutShell) {
      checkoutShell.hidden = !purchaseAvailable;
    }
    if (section.classList.contains('nc-purchase')) {
      const quantityShell = section.querySelector('[data-quantity-shell]');
      if (quantityShell) quantityShell.hidden = !purchaseAvailable;
    }

    if (waitlistPanel) {
      waitlistPanel.hidden = purchaseAvailable && !notifyHasMessage;
    }

    if (notifyShell) {
      notifyShell.hidden = purchaseAvailable && !notifyHasMessage;
    }

    if (trustWaitlist) {
      trustWaitlist.hidden = purchaseAvailable;
    }

    if (trustCheckout) {
      trustCheckout.hidden = !purchaseAvailable;
    }

    if (notifyTagsInput && variant.notifyTags) {
      notifyTagsInput.value = variant.notifyTags;
    }

    syncNotifyLabel();

    let variantImageHandled = false;

    if (mediaItems.some(item => item.blackSrc)) {
      setMedia(currentMediaIndex);
      variantImageHandled = true;
    }
    if (!variantImageHandled && variant.image && mediaItems.length) {
      const mediaIndex = mediaItems.findIndex((item) => item.src === variant.image);
      if (mediaIndex >= 0) {
        setMedia(mediaIndex);
        variantImageHandled = true;
      }
    }

    if (!variantImageHandled && mainImage && variant.image) {
      if (variant.imageSrcset) {
        setImageAttribute(mainImage, 'srcset', variant.imageSrcset);
      } else {
        setImageAttribute(mainImage, 'srcset', '');
      }
      mainImage.sizes = '(min-width: 990px) min(44vw, 44rem), 92vw';
      setImageAttribute(mainImage, 'src', variant.image);
      mainImage.alt = variant.imageAlt || '';
    }

    syncPairImage();
    syncPackBonus();
    dispatchProductContext();
    return true;
  };

  section.querySelectorAll('[data-option-button]').forEach((button) => {
    button.addEventListener('click', () => {
      const group = button.closest('[data-option-group]');
      if (!group) return;

      const previousButton = group.querySelector('[data-option-button][aria-pressed="true"]');

      group.querySelectorAll('[data-option-button]').forEach((optionButton) => {
        optionButton.classList.toggle('is-active', optionButton === button);
        optionButton.setAttribute('aria-pressed', optionButton === button ? 'true' : 'false');
      });

      const selectedLabel = group.querySelector('[data-option-selected-label]');
      if (selectedLabel) selectedLabel.textContent = button.dataset.optionLabel || button.dataset.optionValue || '';
      const headingValue = group.querySelector('[data-option-heading-value]');
      if (headingValue) headingValue.textContent = button.dataset.optionLabel || button.dataset.optionValue || '';

      syncPackBonus();
      const changed = syncVariant();
      if (changed) writeBuildToUrl();
      if (!changed && previousButton instanceof HTMLElement) {
        group.querySelectorAll('[data-option-button]').forEach((optionButton) => {
          optionButton.classList.toggle('is-active', optionButton === previousButton);
          optionButton.setAttribute('aria-pressed', optionButton === previousButton ? 'true' : 'false');
        });

        const previousLabel = previousButton.dataset.optionLabel || previousButton.dataset.optionValue || '';
        if (selectedLabel) selectedLabel.textContent = previousLabel;
        if (headingValue) headingValue.textContent = previousLabel;
        syncPackBonus();
      }
    });
  });

  section.querySelectorAll('[data-addon-input]').forEach((input) => {
    input.addEventListener('change', () => {
      const group = input.closest('[data-addon-group]');
      if (!group) return;

      if (input.hasAttribute('data-addon-none')) {
        group.querySelectorAll('[data-addon-input]:not([data-addon-none])').forEach((addonInput) => {
          addonInput.checked = false;
        });
        input.checked = true;
      } else if (input.checked) {
        const noneInput = group.querySelector('[data-addon-none]');
        if (noneInput) noneInput.checked = false;
      }

      syncAddonGroup(group);
      syncPriceDisplay();
      syncAccessoryPrices();
      syncPurchaseMessaging(currentVariant);
      syncNotifyLabel();
      dispatchProductContext();
      writeBuildToUrl();
    });
  });

  batteryCapacityInputs.forEach((input) => {
    input.addEventListener('change', () => {
      syncBatteryCapacityChoices();
      syncPriceDisplay();
      syncAccessoryPrices();
      syncPurchaseMessaging(currentVariant);
      syncNotifyLabel();
      dispatchProductContext();
      writeBuildToUrl();
    });
  });

  addButton?.addEventListener('click', () => {
    setCheckoutDestination('');
  });

  buyNowButton?.addEventListener('click', () => {
    setCheckoutDestination('/checkout');
  });

  soundDemoCtas.forEach((cta) => {
    cta.addEventListener('click', () => {
      trackProductEvent('sound_demo_cta_click', {
        destination: cta.getAttribute('href') || ''
      });
    });
  });

  reserveBuildButton?.addEventListener('click', () => {
    trackProductEvent('reserve_build_cta_click');
  });

  notifyForm?.addEventListener('submit', () => {
    trackProductEvent('email_reservation_submit', {
      emailProvided: Boolean(notifyEmailInput?.value)
    });
  });

  quantityInput?.addEventListener('change', () => {
    if (!quantityInput) return;
    syncQuantityControls(quantityInput.value);
  });

  const prevButton = section.querySelector('[data-media-prev]');
  const nextButton = section.querySelector('[data-media-next]');
  prevButton?.addEventListener('pointerdown', () => preloadMedia(currentMediaIndex - 1), { passive: true });
  nextButton?.addEventListener('pointerdown', () => preloadMedia(currentMediaIndex + 1), { passive: true });
  prevButton?.addEventListener('click', () => {
    setMedia(currentMediaIndex - 1, -1);
    warmGallery();
  });

  nextButton?.addEventListener('click', () => {
    setMedia(currentMediaIndex + 1, 1);
    warmGallery();
  });

  mediaThumbs.forEach((thumb) => {
    const index = () => Number(thumb.dataset.mediaIndex || 0);
    thumb.addEventListener('pointerdown', () => preloadMedia(index()), { passive: true });
    thumb.addEventListener('click', () => {
      setMedia(index(), index() < currentMediaIndex ? -1 : 1);
      warmGallery();
    });
  });

  section.querySelectorAll('[data-fit-tab]').forEach((tab) => {
    tab.addEventListener('click', () => {
      const tabId = tab.dataset.fitTab;
      if (!tabId) return;

      section.querySelectorAll('[data-fit-tab]').forEach((candidate) => {
        const isActive = candidate === tab;
        candidate.classList.toggle('is-active', isActive);
        candidate.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      section.querySelectorAll('[data-fit-panel]').forEach((panel) => {
        const isActive = panel.dataset.fitPanel === tabId;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    });
  });

  applyBuildFromUrl();
  syncMediaThumbs();
  if (section.classList.contains('nc-purchase')) {
    setMedia(currentMediaIndex);
  }
  section.querySelectorAll('[data-addon-group]').forEach(syncAddonGroup);
  syncPackBonus();
  syncVariant();
  syncNotifyLabel();
  if (section.classList.contains('nc-purchase') && mainImage) {
    const onFirstProductImage = () => {
      mainImage.decode().catch(() => {}).finally(() => {
        const finishButton = section.querySelector('[data-option-kind="color"] [data-option-button][aria-pressed="true"]');
        warmAdjacentMedia(/black/i.test(finishButton?.dataset.optionLabel || finishButton?.dataset.optionValue || ''));
      });
    };
    if (mainImage.complete && mainImage.naturalWidth) onFirstProductImage();
    else mainImage.addEventListener('load', onFirstProductImage, { once: true });
  }
  section.querySelectorAll('[data-addon-key]:not([data-addon-bonus])').forEach((input) => { input.disabled = !addonVariant(input); });

  if (form) {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (cartSubmitting) return;
      const build = currentBuild();
      if (!build.available) {
        cartError.textContent = unavailableText;
        cartError.hidden = false;
        syncPurchaseMessaging();
        return;
      }
      const items = build.items;
      const properties = {};
      new FormData(form).forEach((value, key) => {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && value) properties[match[1]] = value;
      });
      if (Object.keys(properties).length) items[0].properties = properties;
      const destination = event.submitter === buyNowButton ? `${window.Shopify?.routes?.root || '/'}checkout` : cartUrl;
      cartSubmitting = true;
      form.setAttribute('aria-busy', 'true');
      cartError.hidden = true;
      syncPurchaseMessaging();
      try {
        const response = await fetch(cartAddUrl, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : cartErrorText);
        window.location.assign(destination);
      } catch (error) {
        cartError.textContent = error.message || cartErrorText;
        cartError.hidden = false;
      } finally {
        cartSubmitting = false;
        form.removeAttribute('aria-busy');
        syncPurchaseMessaging();
      }
    });
  }
  };
  const start = () => {
    for (const node of document.querySelectorAll('script[data-neuracoil-product-config]')) initialize(JSON.parse(node.textContent));
  };
  if (window.NeuraCoilBuild) start();
  else document.querySelector('[data-neuracoil-build-script]')?.addEventListener('load', start, { once: true });
})();
